import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";

import { TableComponent } from "../../Partials/Table/TableComponent";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { TabsComponent } from "./TabsComponent";

import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
// import Radio from '@material-ui/core/Radio';
// import RadioGroup from '@material-ui/core/RadioGroup';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
import Time from "../../../Time/Time";

class Notifications extends Component {
  protected paginatorPath: string = !!this.props.app.notificationsFilterSearchState ?
    `Notifications_${this.props.app.notificationsFilterState}_${this.props.app.notificationsFilterSearchState}` :
    `Notifications_${this.props.app.notificationsFilterState}`;
  protected userId: number = this.props.app.session.user.id;

  public state = {
    isDeleteNotificationPopupOpen: false,
    currentNotification: null,
    notifications: [],
    openNotifications: [],
    notificationsCount: 0,
    openNotificationsCount: 0,
    filter: "all",
    isSaving: false,
    anchorEl: null,
    isFetching: true,
    filterValue: "all"
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.fetchFirstOpenNotifications();
    this.fetchFirstAllNotifications();
  }

  public componentWillReceiveProps(nextProps) {
    if (!this.props?.events?.requestsOutdated && nextProps?.events?.requestsOutdated) {
      this.fetchFirstAllNotifications()
    }
  }

  public fetchFirstAllNotifications = () => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath] : this.props.app.defaultPaginationAmount;

    const payload: any = {
      offset: 0,
      limit: paginationAmount,
      // filterValue: this.state.filterValue,
      eventTypeIds: [
        // 15, // unpaid charge
        // 16, // expiring contract
        // 33, // adjust contract prices
        3,
        16
      ],
      removed: 0,
      isSnoozed: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: () => {
        const activeNotifications = this.props.events?.reminders?.filter(r => !r.reacted && !r.removed && !r.object.removed && r.object.isActive && [3, 16].includes(r.eventTypeId) && Time.todayOrEarlier(r.remindDate) && r.remindDate && r.content?.name)
        this.setState({
          notifications: activeNotifications,
          notificationsCount: activeNotifications.length,
          isFetching: false
        })
      }
    });
  }

  public fetchFirstOpenNotifications = () => {
    const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
      this.props.app.paginator[this.paginatorPath] : this.props.app.defaultPaginationAmount;

    const payload: any = {
      offset: 0,
      limit: paginationAmount,
      // filterValue: this.state.filterValue,
      eventTypeIds: [
        // 15, // unpaid charge
        // 16, // expiring contract
        // 33  // adjust contract prices
        3, 16
      ],
      removed: 0,
      reacted: 0,
      isSnoozed: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: () => {
        const activeNotifications = this.props.events?.reminders?.filter(r => !r.reacted && !r.removed && !r.object.removed && r.object.isActive && [3, 16].includes(r.eventTypeId) && Time.todayOrEarlier(r.remindDate) && r.remindDate && r.content?.name)
        this.setState({
          openNotifications: activeNotifications,
          openNotificationsCount: activeNotifications.length,
          isFetching: false
        })
      }
    });
  }

  public fetchFilterAllNotifications = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        // filterValue: this.state.filterValue,
        eventTypeIds: [

          3, 16
          // 15, // unpaid charge
          // 16, // expiring contract
          // 33  // adjust contract prices
        ],
        removed: 0,
        isSnoozed: 0
      },
      onSuccess: () => {
        const activeNotifications = this.props.events?.reminders?.filter(r => {
          return r.reacted || r.removed || r.object.removed || !r.object.isActive || ![3, 16].includes(r.eventTypeId) || !Time.todayOrEarlier(r.remindDate) || !r.remindDate || !r.content?.name
        })
        this.setState({
          notifications: activeNotifications,
          notificationsCount: activeNotifications.length,
          isFetching: false
        })
      }
    })
  }

  public fetchFilterOpenNotifications = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        // filterValue: this.state.filterValue,
        eventTypeIds: [
          3, 16
          // 15, // unpaid charge
          // 16, // expiring contract
          // 33  // adjust contract prices
        ],
        removed: 0,
        reacted: 0,
        isSnoozed: 0
      },
      onSuccess: data => {
        this.setState({
          openNotifications: data.events,
          openNotificationsCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public clearFilterAllNotifications = () => {
    this.props.dispatch({
      type: Constants.NOTIFICATIONS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstAllNotifications);
  }

  public clearFilterOpenNotifications = () => {
    this.props.dispatch({
      type: Constants.NOTIFICATIONS_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstOpenNotifications);
  }

  protected onEnter = (event): any => {
    if (event.key === "Enter") {
      this.paginatorPath = !!this.state.filterValue ?
        `Notifications_${this.state.filter}_${this.state.filterValue}` :
        `Notifications_${this.state.filter}`;

      this.props.dispatch({
        type: Constants.NOTIFICATIONS_FILTER_SEARCH_UPDATE_STATE,
        payload: {
          filter: this.state.filterValue
        }
      });

      if (this.state.filter === "all") {
        this.fetchFirstAllNotifications();
      } else {
        this.fetchFirstOpenNotifications();
      }
    }
  }

  public setFilterValue = (event): any => {
    this.setState({
      filterValue: event.target.value
    }, () => {
      if (this.state.filterValue === "") {
        if (this.state.filter === "all") {
          this.clearFilterAllNotifications();
        } else {
          this.clearFilterOpenNotifications();
        }
      }
    });
  }

  public fetchNotifications = () => {
    if (this.state.filter === "all") {
      const payload: any = {
        offset: !!this.state.notifications ? this.state.notifications.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        // filterValue: this.state.filterValue,
        eventTypeIds: [
          3, 16
          // 15, // unpaid charge
          // 16, // expiring contract
          // 33  // adjust contract prices
        ],
        removed: 0,
        isSnoozed: 0
      };

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          const activeNotifications = data.events.filter(notification => { return !notification.object?.isActive || notification.object?.removed && !Time.todayOrEarlier(notification.remindDate) ? false : true })
          const notificationsArr: EventInterface[] = !!this.state.notifications ?
            [...this.state.notifications, ...activeNotifications] : [...activeNotifications];

          this.setState({
            notifications: notificationsArr,
            notificationsCount: activeNotifications.length,
            isFetching: false
          });
        }
      });
    } else if (this.state.filter === "open") {
      const payload: any = {
        offset: !!this.state.openNotifications ? this.state.openNotifications.length : 0,
        limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeIds: [
          15, // unpaid charge
          16, // expiring contract
          3
        ],
        removed: 0,
        reacted: 0,
        isSnoozed: 0
      };

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: () => {
          const activeNotifications = this.props.events?.reminders?.filter(r => !r.reacted && !r.removed && !r.object.removed && r.object.isActive && [3, 16].includes(r.eventTypeId) && Time.todayOrEarlier(r.remindDate) && r.remindDate && r.content?.name)
          const openNotificationsArr: EventInterface[] = !!this.state.openNotifications ?
            [...this.state.openNotifications, ...activeNotifications] : [...activeNotifications];

          this.setState({
            openNotifications: openNotificationsArr,
            openNotificationsCount: activeNotifications.length,
            isFetching: false
          });
        }
      });
    }
  }

  public changeFilter = (event: any): void => {
    const filter: string = event.target.value;

    this.setState({
      filter: filter
    }, () => {
      this.paginatorPath = `Notifications_${filter}`;

      this.props.dispatch({
        type: Constants.NOTIFICATIONS_FILTER_UPDATE_STATE,
        payload: {
          filter: filter
        }
      });

      if (filter === "all") {
        if (this.state.filterValue) {
          this.fetchFilterAllNotifications();
        } else {
          this.fetchFirstAllNotifications();
        }
      } else if (filter === "open") {
        if (this.state.filterValue) {
          this.fetchFilterOpenNotifications();
        } else {
          this.fetchFirstOpenNotifications();
        }
      }
    });
  }

  public getAmountsOfFilteredNotifications = (filter: string): number => {
    switch (filter) {
      case "all":
        return this.state.notificationsCount;
      case "open":
        return this.state.openNotificationsCount;
      default:
        return;
    }
  }

  public getFilteredNotifications = (filter: string): EventInterface[] => {
    switch (filter) {
      case "all":
        return this.state.notifications;

      case "open":
        return this.state.openNotifications;
      default:
        return;
    }
  }

  public deleteNotification = (notification) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: notification,
      },
      onSuccess: () => {
        this.closeMenu()
        this.fetchFirstAllNotifications();
        // this.fetchFirstOpenNotifications();
      }
    });
  }

  protected openMenu = (event: any, notification: EventInterface): void => {
    this.setState({
      currentNotification: notification,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public getNotifications = () => {

    return this.getFilteredNotifications(this.state.filter)
      .map((notification: EventInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => {
              return this.redirect(`/app/${notification.object?.nameForUrl}/update/${notification.object?.id}`);
            }}
          >
            <TableCell style={{ width: "24px", paddingLeft: "24px", paddingRight: "0px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                <div
                  className={"icon icon-ic-notification"}
                  style={{
                    color: "#00BCD4",
                    fontSize: "24"
                  }}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>{notification.remindDate && this.formatter.formatDate(new Date(notification.remindDate))}</TableCell>
            <TableCell style={{ width: "40%" }}>{notification.object && notification.object.listDisplayName}</TableCell>
            <TableCell style={{ width: "20%" }}>{notification.content?.name}</TableCell>
            {/* <TableCell style={{width: "15%"}}>{notification.status}</TableCell> */}

            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, notification)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.state.currentNotification && this.state.currentNotification.id === notification.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => {
                      return this.redirect(`/app/${notification.object?.nameForUrl}/update/${notification.object?.id}`)
                    }
                    }
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.deleteNotification(notification)
                    }}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove icon-color remove-icon"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={8}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "48px",
                  maxHeight: "48px"
                }}
              >
                <h3 className="card-title">
                  {this.trans("page/dashboard-tab/notifications")}
                </h3>
              </div>

              <div>
                <div>
                  <div
                    className="list-filters-wrapper"
                  >
                    <div style={{ display: "flex" }}>
                      {/* <RadioGroup
                        name="notificationsFilters"
                        value={this.state.filter}
                        onChange={this.changeFilter}
                        style={{
                          display: "flex",
                          flexDirection: "row"
                        }}
                      >
                        <FormControlLabel
                          value="open"
                          control={<Radio color="primary" />}
                          label={
                            (<span>{this.trans("status-open")}</span>)}
                        />
                        <FormControlLabel
                          value="all"
                          control={<Radio color="primary" />}
                          label={
                            (<span>{this.trans("all")}</span>)}
                        />
                      </RadioGroup> */}
                    </div>
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table tasks-listing-table with-first-border not-3-dot"
                  headers={[
                    "", this.trans("date"), this.trans("object"), this.trans("subject"), ""
                  ]}
                  rows={this.getNotifications()}
                  rowsLength={this.getAmountsOfFilteredNotifications(this.state.filter)}
                  subtitle={this.trans("title-no-notifications-to-list")}
                  fetch={this.fetchNotifications}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    units: state.units,
    component: state.notifications,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(Notifications);
